/**
 * Guardian client log — small in-memory ring buffer of recent app events
 * (JS errors, failed API calls, rejections) used to enrich incident reports.
 * Secrets and base64 blobs are redacted before anything leaves the device.
 */
const MAX = 20;
const events = [];

const redact = (s) =>
  String(s || "")
    .replace(/(bearer\s+)[A-Za-z0-9\-_.]{10,}/gi, "$1[REDACTED]")
    .replace(/(password|token|secret|api[_-]?key)\s*[=:]\s*\S+/gi, "$1=[REDACTED]")
    .replace(/data:image\/[^;]+;base64,[A-Za-z0-9+/=]{40,}/g, "[image-data]")
    .slice(0, 300);

export const recordEvent = (type, message, extra = {}) => {
  events.push({ at: new Date().toISOString(), type, message: redact(message), ...extra });
  if (events.length > MAX) events.shift();
};

export const getRecentEvents = () => [...events];

let installed = false;
export const installGuardianLog = () => {
  if (installed) return;
  installed = true;
  window.addEventListener("error", (e) =>
    recordEvent("js_error", e.message, { src: redact(e.filename || "") }));
  window.addEventListener("unhandledrejection", (e) =>
    recordEvent("promise_rejection", e.reason?.message || String(e.reason || "")));
};

export const recordApiError = (err) => {
  const cfg = err?.config || {};
  recordEvent("api_error", err?.response?.data?.detail || err?.message || "request failed", {
    url: redact(`${(cfg.method || "").toUpperCase()} ${cfg.url || ""}`),
    status: err?.response?.status || 0,
  });
};
